export default __webpack_public_path__ + "static/media/logo.c3c1e3c3.svg";